import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Responsive from 'datatables.net-responsive';
import AreaChart from '../components/charts/AreaChart';
import HeatmapChart from '../components/charts/HeatmapChart';
import DoughnutChart from '../components/charts/DoughnutChart';
import VectorMap from '../components/charts/VectorMap';

DataTable.use(DT);
DataTable.use(Responsive);

const Restaurant: React.FC = () => {
    const [, setDtApi] = useState<any>(null);

    const options = useMemo(() => ({
        responsive: true,
        pageLength: 5,
        lengthChange: false,
        searching: false,
        dom: 'rtip',
        initComplete: (settings: any) => {
            const api = new DT.Api(settings);
            setDtApi(api);
        }
    }), []);

    const referralData = useMemo(() => [
        {
            name: 'Reddy John',
            location: 'New Jersey, UK',
            image: 'assets/img/adminuiux/user-1.jpg',
            tasks: 5250,
            earning: '$ 11523',
            status: 'Active',
            statusClass: 'theme-green'
        },
        {
            name: 'Utkarshaa Dev',
            location: 'New Jersey, UK',
            image: 'assets/img/adminuiux/user-6.jpg',
            tasks: 3250,
            earning: '$ 15545',
            status: 'Active',
            statusClass: 'theme-green'
        },
        {
            name: 'Nil William',
            location: 'London, UK',
            image: 'assets/img/adminuiux/user-2.jpg',
            tasks: 1250,
            earning: '$ 25545',
            status: 'Inactive',
            statusClass: 'theme-red'
        },
        {
            name: 'Sanya Tandon',
            location: 'Wembley, UK',
            image: 'assets/img/adminuiux/user-8.jpg',
            tasks: 5250,
            earning: '$ 11523',
            status: 'Away',
            statusClass: 'theme-orange'
        }
    ], []);

    const heatmapData = useMemo(() => {
        const xLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const yLabels = ['12am', '2am', '4am', '6am', '8am', '10am', '12pm', '2pm', '4pm', '6pm', '8pm', '10pm'];
        const data = yLabels.map(() =>
            xLabels.map((_, i) => {
                // Creating a peak around mid-day (index 6-7)
                const hourPeak = 80 - Math.abs(6 - i) * 10;
                return Math.max(0, hourPeak + Math.floor(Math.random() * 40));
            })
        );
        return { data, xLabels, yLabels };
    }, []);
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row gx-3 gx-lg-4 align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Restaurant</h6>
                        <p className="text-secondary small">Manage orders, customers, and more...</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Restaurant</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="card bg-theme-r-gradient mb-3 mb-lg-4">
                    <div className="card-body pb-0">
                        <h4 className="text-center mb-1">The FoodyZone, Start Exploring!</h4>
                        <p className="text-center">Informations are provided based on complete orders and delivery</p>
                        <div className="row gx-3 gx-lg-4">
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className="card border-0 shadow-sm mb-3">
                                    <div className="card-body">
                                        <p className="text-secondary small mb-1"><span>Total Earning</span></p>
                                        <h5 className="mb-1">$ 1765</h5>
                                        <p><small className="text-theme-1 theme-green"><i className="bi bi-caret-up-fill"></i> $ 250</small> <small className="text-secondary">Today</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className="card border-0 shadow-sm mb-3">
                                    <div className="card-body">
                                        <p className="text-secondary small mb-1"><span>Total Expense</span></p>
                                        <h5 className="mb-1">$ 1530</h5>
                                        <p><small className="text-theme-1 theme-red"><i className="bi bi-caret-down-fill"></i> $ 250</small> <small className="text-secondary">Today</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className="card border-0 shadow-sm mb-3">
                                    <div className="card-body">
                                        <p className="text-secondary small mb-1"><span>Order Received</span></p>
                                        <h5 className="mb-1">7230</h5>
                                        <p><small className="text-theme-1 theme-green"><i className="bi bi-caret-up-fill"></i> 245</small> <small className="text-secondary">Today</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className="card border-0 shadow-sm mb-3">
                                    <div className="card-body">
                                        <p className="text-secondary small mb-1"><span>New Customer</span></p>
                                        <h5 className="mb-1">$ 1530</h5>
                                        <p><small className="text-theme-1 theme-green"><i className="bi bi-caret-up-fill"></i> 10%</small> <small className="text-secondary">Today</small></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* sales analytics */}
                <div className="card mb-3 mb-lg-4">
                    <div className="card-header">
                        <div className="row gx-3 gx-lg-4 align-items-center">
                            <div className="col">
                                <h6 className="mb-1">Restaurant Orders</h6>
                                <p className="text-secondary small">Informations are provided based on complete orders and delivery </p>
                            </div>
                            <div className="col-auto">
                                <button className="btn btn-sm btn-theme-1"><i className="bi bi-download"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <AreaChart labels={['1', '2', '3', '4', '5', '7', '8', '9', '10']}
                            datasets={[
                                {
                                    type: 'bar',
                                    data: [15, 10, 20, 15, 25, 20, 15, 10, 30, 15],
                                    label: 'Dine-in',
                                    color: '#471ca8',
                                    fillColor: 'rgba(147, 112, 219, 0.5)',
                                    borderWidth: 1,
                                    pointBackgroundColor: '#471ca8',
                                    pointBorderColor: '#ffffff',
                                    pointRadius: 1,
                                    tension: 0.4,
                                    borderColor: '#471ca8',
                                },
                                {
                                    type: 'bar',
                                    data: [15, 10, 30, 15, 12, 10, 20, 15, 25, 20,],
                                    label: 'Takeaway',
                                    color: '#fc7a1e',
                                    fillColor: 'rgba(219, 112, 137, 0.5)',
                                    borderWidth: 1,
                                    pointBackgroundColor: '#fc7a1e',
                                    pointBorderColor: '#ffffff',
                                    pointRadius: 4,
                                    tension: 0.4,
                                    borderColor: '#fc7a1e',
                                },
                                {
                                    type: 'line',
                                    data: [20, 15, 15, 10, 20, 15, 25, 20, 10, 30],
                                    label: 'Delivery',
                                    color: '#00c851',
                                    fillColor: 'rgba(0, 200, 81, 0.5)',
                                    borderWidth: 2,
                                    pointBackgroundColor: '#00c851',
                                    pointBorderColor: '#ffffff',
                                    pointRadius: 4,
                                    tension: 0.4,
                                    borderColor: '#00c851',
                                },
                            ]}
                            scalesx={true}
                            scalesy={true}
                            height={180} />
                    </div>
                    <div className="card-footer">
                        <div className="row gx-3">
                            <div className="col-6 col-lg-3 mb-3 mb-lg-0">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-purple">
                                            <i className="bi bi-cart h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Dine-In</p>
                                        <h5>2258</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3 mb-3 mb-lg-0">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-green">
                                            <i className="bi bi-arrow-up-right h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Delivery</p>
                                        <h5>1158</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-orange">
                                            <i className="bi bi-coin h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Takeaway</p>
                                        <h5>1526</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-cyan">
                                            <i className="bi bi-bar-chart h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Profit</p>
                                        <h5>$ 52.15 k</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* traffic and orders  */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-12 col-lg-6">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col">
                                        <h6 className="mb-1">Orders Statistic & KOT</h6>
                                        <p className="text-secondary small">Status of orders and prepared orders</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="tab-content">
                                    <div className="tab-pane fade active show" id="tabhome1" role="tabpanel">
                                        <div className="height-180">
                                            <AreaChart labels={['1', '2', '3', '4', '5', '7', '8', '9', '10']}
                                                datasets={[
                                                    {
                                                        data: [15, 10, 20, 15, 25, 20, 15, 10, 30, 15],
                                                        label: 'Income',
                                                        color: '#9370DB',
                                                        fillColor: 'rgba(185, 135, 250, 0.5)',
                                                        borderWidth: 2,
                                                        pointBackgroundColor: '#9370DB',
                                                        pointBorderColor: '#ffffff',
                                                        pointRadius: 5,
                                                        tension: 0,
                                                        borderColor: '#9370DB',
                                                    },
                                                ]}
                                                scalesx={true}
                                                scalesy={true}
                                                height={180} />
                                        </div>
                                    </div>
                                    <div className="tab-pane fade overflow-y-auto height-180" id="tabhome3" role="tabpanel">
                                        <div className="">
                                            <table className="table table-sm mb-0 align-middle">
                                                <thead>
                                                    <tr>
                                                        <th>KOT #</th>
                                                        <th>Table</th>
                                                        <th>Order Details</th>
                                                        <th className="text-end">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>#2056</td>
                                                        <td>T-12</td>
                                                        <td>
                                                            <p className="mb-0">2x Paneer Tikka</p>
                                                            <p className="text-secondary small mb-0">1x Butter Naan</p>
                                                        </td>
                                                        <td className="text-end"><span className="badge badge-light text-bg-theme-1 theme-yellow">Cooking</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#2055</td>
                                                        <td>T-04</td>
                                                        <td>
                                                            <p className="mb-0">1x Veg Biryani</p>
                                                            <p className="text-secondary small mb-0">Spicy: Medium</p>
                                                        </td>
                                                        <td className="text-end"><span className="badge text-bg-theme-1 theme-red">Pending</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#2054</td>
                                                        <td>T-08</td>
                                                        <td>
                                                            <p className="mb-0">1x Dal Makhani</p>
                                                            <p className="text-secondary small mb-0">2x Jeera Rice</p>
                                                        </td>
                                                        <td className="text-end"><span className="badge badge-light text-bg-theme-1 theme-green">Ready</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#2053</td>
                                                        <td>T-02</td>
                                                        <td>
                                                            <p className="mb-0">2x Masala Dosa</p>
                                                            <p className="text-secondary small mb-0">Extra Chutney</p>
                                                        </td>
                                                        <td className="text-end"><span className="badge badge-light text-bg-theme-1 theme-cyan">Served</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#2052</td>
                                                        <td>T-10</td>
                                                        <td>
                                                            <p className="mb-0">1x Grilled Sandwich</p>
                                                            <p className="text-secondary small mb-0">No Cheese</p>
                                                        </td>
                                                        <td className="text-end"><span className="badge badge-light text-bg-theme-1 theme-yellow">Cooking</span></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer pb-0">
                                <ul className="nav nav-tabs nav-fill adminuiux-tabs" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link active" id="tabhome1-tab" data-bs-toggle="tab" data-bs-target="#tabhome1" role="tab" aria-controls="tabhome1" aria-selected="true">
                                            <h4 className="mb-1">1.45 k</h4>
                                            <p className="text-secondary mb-0 small"><span className="text-theme-1 theme-green">+15%</span><br /> Active</p>
                                        </a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link" id="tabhome2-tab" data-bs-toggle="tab" data-bs-target="#tabhome1" role="tab" aria-controls="tabhome1" aria-selected="false" >
                                            <h4 className="mb-1">150</h4>
                                            <p className="text-secondary mb-0 small"><span className="text-theme-1 theme-green">+20%</span><br /> Delivered</p>
                                        </a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link" id="tabhome3-tab" data-bs-toggle="tab" data-bs-target="#tabhome3" role="tab" aria-controls="tabhome3" aria-selected="false" >
                                            <h4 className="mb-1">121</h4>
                                            <p className="text-secondary mb-0 small"><span className="text-theme-1 theme-green">+5%</span><br /> KOT</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col">
                                        <h6 className="mb-1">Traffic time</h6>
                                        <p className="text-secondary small">Here is best time for visitors</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body text-center">
                                {/* heatmap chart */}
                                <HeatmapChart
                                    className="height-270 w-100 d-block position-relative"
                                    data={heatmapData.data}
                                    xLabels={heatmapData.xLabels}
                                    yLabels={heatmapData.yLabels}
                                    height={270}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col">
                                        <h6 className="mb-1">210 Orders</h6>
                                        <p className="text-secondary small">New received orders</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pt-2">
                                <div className="width-200 position-relative mx-auto">
                                    <DoughnutChart
                                        labels={['IA', 'NY', 'LA', 'SA', 'SV']}
                                        data={[40, 10, 15, 25, 10]}
                                        colors={['#e5e2ecff', '#3ee782', '#fb38b4ff', '#9c63f7ff', '#2ebeefff']}
                                        cutout="70%"
                                        height={200}
                                    />
                                    <div className="avatar avatar-140 rounded-circle position-absolute top-50 start-50 translate-middle z-index-1">
                                        <div className="w-100 lh-20">
                                            <h5 className="mb-1">2,55.98K</h5>
                                            <p className="text-theme-1 theme-green">18.71 (0.73%)</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1">
                                            <i className="bi bi-bag-plus"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className="mb-0">209</h5>
                                        <p className="text-secondary small">Product available</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* statistic sales */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6">
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="card-body p-0">
                                <div className="row gx-0">
                                    <div className="col p-4">
                                        <h6 className="text-theme-1 mb-3">Employees Statistics</h6>
                                        <h2>48514 <small>hrs</small></h2>
                                        <p className="text-secondary">Your employees are worked hard this week and there are 15 people hired.</p>
                                        <p><span className="text-theme-1 theme-green">250</span> <span className="text-secondary">more hours utilized</span></p>
                                    </div>
                                    <div className="col-12 col-md-auto text-end bg-theme-1 theme-yellow">
                                        <img src={asset("assets/img/adminuiux/cook.png")} alt="" className="h-100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="card mb-3 mb-lg-4 bg-theme-r-gradient overflow-hidden theme-green">
                            <div className="card-body p-0">
                                <div className="row no-gutters">
                                    <div className="col p-4">
                                        <h6 className="mb-3">Sales</h6>
                                        <h2>$ 17450.00</h2>
                                        <p className="opacity-75">Total sales made today and sales payment has been released.</p>
                                        <p><span>$ 150</span> <span className="opacity-75">more budget utilized</span></p>
                                    </div>
                                    <div className="col-12 col-md-auto text-center align-self-center">
                                        <img src={asset("assets/img/adminuiux/burger.png")} alt="" className="mw-100 mb-3" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* popular zone*/}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-6">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-1">Referral Earnings</h6>
                                        <p className="text-secondary small">Top users with highest referral earnings </p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <DataTable className="table mb-3" options={options}>
                                    <thead>
                                        <tr>
                                            <th>User</th>
                                            <th className="none">Tasks</th>
                                            <th className="tablet desktop">Earning</th>
                                            <th className="tablet desktop">Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {referralData.map((user, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="row gx-3">
                                                        <div className="col-auto">
                                                            <figure className="avatar avatar-40 rounded">
                                                                <img src={window.asset ? window.asset(user.image) : user.image} alt="" />
                                                            </figure>
                                                        </div>
                                                        <div className="col">
                                                            <h6 className="mb-1">{user.name}</h6>
                                                            <p className="text-secondary small">{user.location}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <h6 className="mb-1">{user.tasks}</h6>
                                                    <p className="text-secondary small">Task</p>
                                                </td>
                                                <td>
                                                    <h6 className="mb-1">{user.earning}</h6>
                                                    <p className="text-secondary small">Total Earning</p>
                                                </td>
                                                <td><span className={`badge badge-light text-bg-theme-1 ${user.statusClass}`}><span className="bg-theme-1 rounded-circle avatar avatar-10"></span> {user.status}</span></td>
                                                <td>
                                                    <button className="btn btn-link btn-sm btn-square me-1"><i className="bi bi-pencil"></i></button>
                                                    <button className="btn btn-sm btn-square btn-link theme-green"><i className="bi bi-telephone"></i></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-1">Most Popular Zone</h6>
                                        <p className="text-secondary small">Top countires with highest orders </p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <VectorMap height={140} />
                            </div>
                            <div className="card-footer py-0 border-top">
                                <div className="row gx-4">
                                    <div className="col py-3">
                                        <p className="text-secondary mb-1">Daily Sales</p>
                                        <h4 className="font-weight-light mb-0">$1740</h4>
                                        <p className="text-theme-1 theme-green small">+$250</p>
                                    </div>
                                    <div className="col-auto px-0 border-start"></div>
                                    <div className="col py-3">
                                        <p className="text-secondary mb-1">Raw Material</p>
                                        <h4 className="font-weight-light mb-0">$1750</h4>
                                        <p className="text-theme-1 theme-red small">-$250</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
};

export default Restaurant;
